.mainPaper {
}

.forgetPassword {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: right;
	align-items: center;
	margin-right: 0px;
}

.signInSignUpSeperator {
	margin-top: 10px !important;
	margin-bottom: 10px !important;
}

.signUpButton {
	background-color: var(--green) !important;
	color: white !important;
}
